/**
 * The model's numeric rules: its length resolution (every edited length lands
 * on a half inch) and the clamp the edit catalog applies after rounding.
 */

export function clamp(value: number, minimum: number, maximum: number): number {
  return Math.min(maximum, Math.max(minimum, value));
}

/** The model's length resolution (ft): every edited length lands on a half inch. */
const HALF_INCHES_PER_FOOT = 24;
export const HALF_INCH = 1 / HALF_INCHES_PER_FOOT;

/**
 * Round a length (ft) to the nearest half inch. Every setter in the edit
 * catalog applies this to the length it is handed BEFORE clamping, so finer
 * fractions never enter the model and a clamp still wins at a constraint's
 * edge. Never yields negative zero.
 */
export function roundToHalfInch(feet: number): number {
  const rounded = Math.round(feet * HALF_INCHES_PER_FOOT) / HALF_INCHES_PER_FOOT;
  return rounded === 0 ? 0 : rounded;
}
